import {
    STORE_ITEM_TABLE_DATA,
    STORE_ITEM_TABLE_DATA_FAILURE,
    STORE_ITEM_TABLE_DATA_SUCCESS,
    STORE_SELECTED_PRODUCTS_DATA,
    RESET_STORE_ITEM_TABLE_DATA,
} from '../actions/actionTypes';

const initialState = {
    itemTableData: [],
    isItemAdded: false,
    loading: false,
    selectedProducts: [],
};

const getStoreItemTableDataReducerConsignmentAdd = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case STORE_ITEM_TABLE_DATA:
            return {
                ...state,
                itemTableData: action.payload,
                isItemAdded: false,
                loading: true,
                selectedProducts: state.selectedProducts,
            };
        case STORE_ITEM_TABLE_DATA_SUCCESS:
            return {
                ...state,
                itemTableData: action.payload,
                isItemAdded: false,
                loading: false,
                selectedProducts: state.selectedProducts,
            };
        case STORE_ITEM_TABLE_DATA_FAILURE:
            return {
                ...state,
                itemTableData: action.payload,
                isItemAdded: false,
                loading: false,
                selectedProducts: state.selectedProducts,
            };
        case STORE_SELECTED_PRODUCTS_DATA:
            return {
                ...state,
                selectedProducts: action.payload,
            };
        case RESET_STORE_ITEM_TABLE_DATA:
            return {
                ...state,
                itemTableData: action.payload,
                isItemAdded: false,
                selectedProducts: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default getStoreItemTableDataReducerConsignmentAdd;
